import React from 'react'
import {
  AMOUNT_RANGE_CONDITION_NAMES,
  ConditionName,
  Option,
  OptionSetType,
  PEOPLE_RANGE_CONDITION_NAMES,
  PeriodConditionName,
  PeriodParams,
  PERIOD_CONDITION_NAMES,
  RangeParams,
} from '../../actions'
import { SelectConditionName } from '../../constants/conditions'
import AmountRangeCondition from './AmountRangeCondition'
import Condition from './Condition'
import { BaseProps } from './ConditionList'
import PeopleRangeCondition from './PeopleRangeCondition'
import PeriodCondition from './PeriodCondition'
import PrefectureCondition from './PrefectureCondition'
import CrunchbaseLatestRoundTypeCondition from './CrunchbaseLatestRoundTypeCondition'

type ConditionCommonProps = {
  open: boolean
  hasError: boolean
  name: ConditionName
  selected: any
  onToggle: (cond: ConditionName) => void
  onRemove: (cond: ConditionName) => void
  onSelectOption: (cond: ConditionName, option: Option) => void
  onSelectOptionList: (
    cond: ConditionName,
    options: Option[],
    setType: OptionSetType
  ) => void
  onSelectPeriod: (cond: ConditionName, period: PeriodParams) => void
  onSelectRange: (cond: ConditionName, range: RangeParams) => void
}

const AmountConditionItem = (props: ConditionCommonProps) => {
  const selectorProps = {
    onSet: props.onSelectRange,
    from: props.selected.from,
    to: props.selected.to,
  }
  return <AmountRangeCondition {...props} {...selectorProps} />
}

const PeopleConditionItem = (props: ConditionCommonProps) => {
  const selectorProps = {
    onSet: props.onSelectRange,
    from: props.selected.from,
    to: props.selected.to,
  }
  return <PeopleRangeCondition {...props} {...selectorProps} />
}

const PeriodConditionItem = (props: ConditionCommonProps) => {
  const selectorProps = {
    onSet: props.onSelectPeriod,
    outsideClickIgnoreClass: 'react-datepicker',
    selected: props.selected,
  }

  return (
    <PeriodCondition
      {...props}
      name={props.name as PeriodConditionName}
      {...selectorProps}
    />
  )
}

const StateConditionItem = (props: ConditionCommonProps) => {
  const selectorProps = {
    onSelect: props.onSelectOption,
    onSelectList: props.onSelectOptionList,
    selected: props.selected,
  }

  return <PrefectureCondition {...props} {...selectorProps} />
}

const CrunchbaseLatestRoundTypeConditionItem = (
  props: ConditionCommonProps
) => {
  const selectorProps = {
    ...props,
    name: props.name as SelectConditionName,
  }

  return <CrunchbaseLatestRoundTypeCondition {...selectorProps} />
}

export const DefaultConditionItem = (props: ConditionCommonProps) => {
  const selectorProps = {
    onSelect: props.onSelectOption,
    selected: props.selected,
  }

  return (
    <Condition
      {...props}
      name={props.name as SelectConditionName}
      {...selectorProps}
    />
  )
}

type ConditionItemProps = {
  name: any // TODO
  selected: string
} & BaseProps

export const ConditionItem = ({
  name,
  selected,
  opening,
  errors,
  ...props
}: ConditionItemProps) => {
  const open = name === opening
  const hasError = errors.includes(name)
  const commonProps = { selected, open, hasError, name, ...props }

  if (AMOUNT_RANGE_CONDITION_NAMES.includes(name)) {
    return <AmountConditionItem {...commonProps} />
  }
  if (PEOPLE_RANGE_CONDITION_NAMES.includes(name)) {
    return <PeopleConditionItem {...commonProps} />
  }
  if (PERIOD_CONDITION_NAMES.includes(name)) {
    return <PeriodConditionItem {...commonProps} />
  }
  if (name === 'state') {
    return <StateConditionItem {...commonProps} />
  }
  if (name === 'cbLatestRoundType') {
    return <CrunchbaseLatestRoundTypeConditionItem {...commonProps} />
  }
  return <DefaultConditionItem {...commonProps} />
}
